import React from "react";
import { useTranslation } from "react-i18next";

export default function ProfileProgressionSummary({ progressionView }) {
  const { t } = useTranslation();
  const {
    badgeSrc,
    showPrivateDetails,
    currentRankName,
    joinedMonthYear,
    currentLevel,
    milestoneLabel,
    showBioDetails,
    preferenceChips,
    openInfoModal,
  } = progressionView;

  return (
    <div className="profile-progression-header">
      {badgeSrc ? (
        showPrivateDetails ? (
          <button
            type="button"
            className="profile-progression-badge-button"
            onClick={() => openInfoModal("badge")}
            aria-label={t("progression_badge_button_label", {
              defaultValue: "Open badge information",
            })}
          >
            <img
              src={badgeSrc}
              alt={t("progression_current_badge", {
                defaultValue: "Current badge",
              })}
              className="profile-progression-badge"
            />
          </button>
        ) : (
          <img
            src={badgeSrc}
            alt={t("progression_current_badge", {
              defaultValue: "Current badge",
            })}
            className="profile-progression-badge"
          />
        )
      ) : null}

      <div className="profile-progression-header-body">
        <div className="profile-progression-header-top">
          <div className="profile-progression-heading">
            <span className="profile-progression-kicker">
              {t("progression_rank_label", { defaultValue: "Rank" })}
            </span>
            <div className="profile-progression-rank">{currentRankName}</div>
          </div>

          {joinedMonthYear ? (
            <div className="profile-progression-joined">
              {t("profile_progression_joined_label", {
                defaultValue: "Joined {{date}}",
                date: joinedMonthYear,
              })}
            </div>
          ) : null}
        </div>

        <div className="profile-progression-pills">
          <span className="profile-progression-pill profile-progression-pill--accent">
            {t("progression_level_label", {
              defaultValue: "Level {{level}}",
              level: currentLevel,
            })}
          </span>

          {milestoneLabel ? (
            <button
              type="button"
              className="profile-progression-pill profile-progression-pill--milestone profile-progression-pill--interactive"
              onClick={() => openInfoModal("milestone")}
            >
              {milestoneLabel}
            </button>
          ) : null}
        </div>

        {showBioDetails ? (
          <div className="profile-progression-actions">
            <button
              type="button"
              className="profile-progression-bio-button"
              onClick={() => openInfoModal("bio")}
            >
              {t("profile_bio_button_label", {
                defaultValue: "Bio",
              })}
            </button>
          </div>
        ) : null}
      </div>

      {preferenceChips.length ? (
        <div className="profile-mobile-details">
          <div
            className="profile-mobile-preferences"
            aria-label={t("profile_preferences_label", {
              defaultValue: "Fishing preferences",
            })}
          >
            {preferenceChips.map((chip) => (
              <span className="profile-mobile-preference-chip" key={chip.key}>
                {chip.label}
              </span>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
}
